import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body, h1, h2, h3, h4, h5, h6, p, button {
    margin: 0;
    padding: 0;
  }

  ul:not(p ul), ol:not(p ol) {
    margin: 0;
    padding: 0;
  }

  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    font-size: 62.5%;
    background: ${({ theme }) => theme.colors.fill.primary};
  }

  body {
    -webkit-font-smoothing: antialiased;
    font-family: 'ReplicaPro', sans-serif;
    font-size: 1.6em;
    color: ${({ theme }) => theme.colors.typography.default};
  }

  *, *:before, *:after {
    box-sizing: border-box;
  }

  h1 {
    font-size: ${({ theme }) => theme.typographies.h1.fontSize};
    line-height: ${({ theme }) => theme.typographies.h1.lineHeight};
    letter-spacing: ${({ theme }) => theme.typographies.h1.letterSpacing};
    font-weight: ${({ theme }) => theme.typographies.h1.fontWeight};
    margin: 0 0 ${({ theme }) => theme.measures.spacing[5]}px;
    text-transform: uppercase;
  }

  h2 {
    font-size: ${({ theme }) => theme.typographies.h2.fontSize};
    line-height: ${({ theme }) => theme.typographies.h2.lineHeight};
    letter-spacing: ${({ theme }) => theme.typographies.h2.letterSpacing};
    font-weight: ${({ theme }) => theme.typographies.h2.fontWeight};
    margin: 0 0 ${({ theme }) => theme.measures.spacing[2]}px;
  }

  h3 {
    font-size: ${({ theme }) => theme.typographies.h3.fontSize};
    line-height: ${({ theme }) => theme.typographies.h3.lineHeight};
    letter-spacing: ${({ theme }) => theme.typographies.h3.letterSpacing};
    font-weight: ${({ theme }) => theme.typographies.h3.fontWeight};
  }

  h4 {
    font-size: ${({ theme }) => theme.typographies.h4.fontSize};
    line-height: ${({ theme }) => theme.typographies.h4.lineHeight};
    letter-spacing: ${({ theme }) => theme.typographies.h4.letterSpacing};
    font-weight: ${({ theme }) => theme.typographies.h4.fontWeight};
  }

  @media (min-width: ${({ theme }) => theme.measures.breakpoints.tabletSm}) {
    h1 {
      font-size: ${({ theme }) => theme.typographies.h1Large.fontSize};
      line-height: ${({ theme }) => theme.typographies.h1Large.lineHeight};
      letter-spacing: ${({ theme }) =>
        theme.typographies.h1Large.letterSpacing};
      font-weight: ${({ theme }) => theme.typographies.h1Large.fontWeight};
    }
  }

  h3, h4, h5 {
    margin: 0 0 ${({ theme }) => theme.measures.spacing[2]}px;
  }

  h6 {
    margin: 0 0 ${({ theme }) => theme.measures.spacing[2]}px;
  }

  p {
    font-size: ${({ theme }) => theme.typographies.base.fontSize};
    letter-spacing: ${({ theme }) => theme.typographies.base.letterSpacing};
    line-height: ${({ theme }) => theme.typographies.base.lineHeight};
    font-weight: ${({ theme }) => theme.typographies.base.fontWeight};
    margin-bottom: ${({ theme }) => theme.measures.spacing[4]}px;
    max-width: 60ch;
  }
  big {
    font-size: ${({ theme }) => theme.typographies.large.fontSize};
    line-height: ${({ theme }) => theme.typographies.large.lineHeight};
    letter-spacing: ${({ theme }) => theme.typographies.large.letterSpacing};
    font-weight: ${({ theme }) => theme.typographies.large.fontWeight};
  }
  small {
    font-size: ${({ theme }) => theme.typographies.small.fontSize};
    line-height: ${({ theme }) => theme.typographies.small.lineHeight};
    letter-spacing: ${({ theme }) => theme.typographies.small.letterSpacing};
    font-weight: ${({ theme }) => theme.typographies.small.fontWeight};
  }

  button {
    color: inherit;
  }

  a {
    color:  ${({ theme }) => theme.colors.typography.link};
    background-color: transparent;
  }

  svg {
    display: block;
  }

  label {
    font-size: ${({ theme }) => theme.typographies.base.fontSize};
    font-weight: bold;
    display: block;
    margin: 0;
  }
`;
